/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import PedestrianIcon from '../../icons/PedestrianIcon'
import BicycleIcon from '../../icons/BicycleIcon'
import AutoIcon from '../../icons/AutoIcon'
import TransitIcon from '../../icons/TransitIcon'
import FreightIcon from '../../icons/FreightIcon'
import { themeConfig } from '../../config/theme.config'
import { PEDESTRIAN, BICYCLE, TRANSIT, AUTO } from '../../constants/modalTiers'
import getRating from '../../utils/getRating'

export default function WeakestLinkVariables({ name, tierId }) {
  const weakestLinkVariablesArr = useSelector(
    (state) => state.weakestLinkVariables[tierId]
  )
  const weakestLinkScore = useSelector(
    (state) => state.weakestLinkScores[tierId]
  )
  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateRows: '40% 60%',
        maxWidth: '20%',
        width: '20%',
        justifyItems: 'center',
        alignItems: 'center',
        gap: '5px'
      }}
    >
      {/* <hr style={{ marginTop: '0px', borderTop: '1px solid lightGrey' }} /> */}

      {name === PEDESTRIAN ? (
        <PedestrianIcon
          width="100"
          height="105"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === BICYCLE ? (
        <BicycleIcon
          width="100"
          height="105"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === TRANSIT ? (
        <TransitIcon
          width="100"
          height="105"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === AUTO ? (
        <AutoIcon width="100" height="105" fill={themeConfig.semcogLightBlue} />
      ) : (
        <FreightIcon
          width="100"
          height="105"
          fill={themeConfig.semcogLightBlue}
        />
      )}
      <Box sx={{ alignSelf: 'flex-start', mt: '3em' }}>
        {getRating(weakestLinkScore) !== 'Good' &&
        weakestLinkVariablesArr.length ? (
          weakestLinkVariablesArr?.map((variable) => {
            return (
              <Typography
                variant="body1"
                sx={{
                  fontStyle: 'italic',
                  mt: '1em',
                  color: themeConfig.lightTextColor,
                  textOverflow: 'wrap',
                  wordWrap: 'break-word',
                  textAlign: 'center'
                }}
                key={`${variable}-name`}
              >
                {variable}
              </Typography>
            )
          })
        ) : (
          <Typography
            variant="body1"
            sx={{
              fontStyle: 'italic',
              mt: '1em',
              color: themeConfig.lightTextColor,
              textOverflow: 'wrap',
              wordWrap: 'break-word',
              textAlign: 'center'
            }}
          >
            -
          </Typography>
        )}
      </Box>
    </Box>
  )
}

WeakestLinkVariables.propTypes = {
  name: PropTypes.string,
  tierId: PropTypes.string
}
